/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export function pickHeader(headerTheme) {
  switch (headerTheme) {
    case "header_2":
      return import(/* webpackChunkName: "header_2" */ "./components/headers/header-template-two");
    case "header_3":
      return import(/* webpackChunkName: "header_3" */ "./components/headers/header-template-three");
    case "header_4":
      return import(/* webpackChunkName: "header_4" */ "./components/headers/header-template-four");
    case "single-layer-header_1":
      return import(/* webpackChunkName: "single-layer-header_1" */ "./components/headers/single-layer-header-one");
    case "single-layer-header_2":
      return import(/*  webpackChunkName: "single-layer-header_2" */ "./components/headers/single-layer-header-two");
    case "single-layer-header_3":
      return import(/* webpackChunkName: "single-layer-header_3" */ "./components/headers/single-layer-header-three");
    case "single-layer-header_4":
      return import(/* webpackChunkName: "single-layer-header_4" */ "./components/headers/single-layer-header-four");
    case "single-layer-header_5":
      return import(/* webpackChunkName: "single-layer-header_5" */ "./components/headers/single-layer-header-five");
    default:
      return import(/* webpackChunkName: "header_1" */ "./components/headers/header-template-one");
  }
}
